import React, { useState } from 'react'
import RightCard from './RightCard'
import Styles from './Styles.module.css'
import CommonLayout from '../../../../Components/CommonLayout/CommonLayout'
import GoogleMapsComp from '../../../../Components/GoogleMap/GoogleMaps'




function DeliveryManLocation({meta}) {
  const [leftTabs, setLeftTabs] = useState([
    {
      tab: "New",
      isActive: true,
    },
    {
      tab: "Assigned",
      isActive: false
    },
    {
      tab: "On Delivery",
      isActive: false
    },
  ])
  const [rightTabs, setRightTabs] = useState([
    {
      tab: "Free",
      isActive: false,
    },
    {
      tab: "On Job",
      isActive: false
    },
    {
      tab: "Offline",
      isActive: false
    },
  ])
  return (<>
    <div className={[`${Styles.dispatchContainer}`]}>

      <div className={Styles.center}>        
        <div style={{height:"100%",padding:"1rem"}}>
          <CommonLayout />
          <div class={Styles.mapContainer}>
            {/* <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14789.971272134948!2d82.1453587!3d22.0689886!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a280bbf02dd0d65%3A0x7024a8e995e4bd2a!2sNable%20Invent%20Solution%20(INDIA)!5e0!3m2!1sen!2sin!4v1717753795392!5m2!1sen!2sin" width="100%" height="100%" style={{ border: 0 }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}
            <GoogleMapsComp/>
          </div>
        </div>
      </div>

      <div className="right">
        <RightCard tabs={rightTabs} setTab={setRightTabs} sx={{ borderTopLeftRadius: "10px" }} />
      </div>

    </div>
  </>
  )
}

export default DeliveryManLocation